import { t } from 'i18next';
import * as yup from 'yup';

import {
  userEmailSchema,
  userPhoneSchema,
} from '~components/UserForm/userFormValidationSchema';
import { nameIdNonRequiredSchema, nameIdSchemaRequired } from '~constants/regexConst';

export const driverFormValidationSchema = yup.object().shape({
  company: yup
    .object()
    .typeError(
      `${t('form_validation_errors.required', { field: t('form_fields.company') })}`,
    )
    .required(
      `${t('form_validation_errors.required', { field: t('form_fields.company') })}`,
    ),
  firstName: yup
    .string()
    .required(
      `${t('form_validation_errors.required', { field: t('form_fields.first_name') })}`,
    ),
  lastName: yup
    .string()
    .required(
      `${t('form_validation_errors.required', { field: t('form_fields.last_name') })}`,
    ),
  email: userEmailSchema
    .transform((val) => {
      if (!val?.length) {
        return undefined;
      }

      return val;
    })
    .notRequired()
    .when('phone', {
      is: (phone: string | undefined) => {
        return Boolean(!phone || phone.length === 0);
      },
      then: () => {
        return userEmailSchema.required(
          `${t('form_validation_errors.either_one_or_other', { one: t('form_fields.email'), other: t('form_fields.phone') })}`,
        );
      },
    }),
  phone: userPhoneSchema
    .transform((val) => {
      if (!val?.length) {
        return undefined;
      }

      return val;
    })
    .notRequired(),
  address: yup
    .object()
    .shape({
      streetAddress: yup.string().notRequired(),
    })
    .notRequired(),
  timeZone: yup.string().required(),
  notes: yup.string().max(
    350,
    `${t('form_validation_errors.max_length', {
      field: t('form_fields.notes'),
      max: 350,
    })}`,
  ),
  equipment: yup
    .object()
    .shape({
      id: yup.string(),
      name: yup.string(),
    })
    .notRequired(),
  equipmentType: yup
    .object()
    .shape({
      id: yup.string(),
      name: yup.string(),
    })
    .when('equipment', {
      is: (equipment: { id: string; name: string } | null) => {
        return Boolean(equipment?.name);
      },
      then: () => {
        return nameIdSchemaRequired.required();
      },
      otherwise: () => {
        return nameIdNonRequiredSchema.notRequired();
      },
    }),
  createInternalEquipment: yup.boolean(),
  accountName: yup.string().notRequired(),
  accountExternalId: yup.string().notRequired(),
  labels: yup
    .array()
    .of(
      yup.object({
        id: yup.string().required(),
        name: yup.string().required(),
        color: yup.string(),
      }),
    )
    .max(5)
    .notRequired(),
});
